import { redirect } from "react-router-dom";
import { COMPLAINT_CASE_FINISH_PATCH_API } from '../../constants/apis';
import { DESKTOP_PATH, LOGIN_PATH } from '../../constants/paths';
import { patchModel } from '../../utils/functions';
import { DEFAULT_UNKNOWN_ERROR_MESSAGE } from '../../constants/constants';


export async function desktopAction({ params, request }) {
    try {
        switch (request.method) {
            case "POST":
                await patchModel(COMPLAINT_CASE_FINISH_PATCH_API.replace('{id}', params.complaint_case_id), {has_finished: true});

                return redirect(DESKTOP_PATH);
            default:
                return {
                    message: "Esta página possui erros de implementação/desenvolvimento.",
                    parameters: []
                };
        }
    }
    catch(errors) {
        let message = [];
        let parameters = [];

        if(errors instanceof Array) {
            for(let error of errors) {
                if(error.code === 208) {
                    if(error.message.includes('id might be invalid')) {
                        message.push('Caso não encontrado');
                    }
                }
                else if(error.code === 209) {
                    // message.push('Sessão do usuário expirada');
                    return redirect(LOGIN_PATH);
                }
                else if(error.code === 203) {
                    // Not authorized
                    return redirect(DESKTOP_PATH);
                }
            }
        }

        if (message.length <= 0) {
            message = [DEFAULT_UNKNOWN_ERROR_MESSAGE];
        }
    
        return {
            parameters,
            message: `${message.join('; ')}.`
        };
    }
  };